<template>
    <modal name="project-edit-modal" :pivotY="0.2" width="590" height="auto">
        <div class="modal-img-container">
            <img class="modal-img" :src="urlForStatic(titleImage)"/>
        </div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('project-edit-modal')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title">
            Редактировать название проекта
        </div>
        <input class="modal-text-input" type="text" v-model="nameActiveProject">
        <div class="modal-button" @click="writeName">
            Сохранить изменения
        </div>
    </modal>
</template>

<script>
    import {modalMethods, urlForStaticVue} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose";

    export default {
        name: "ModalEditProject",
        components: {SVGModalClose},
        mixins: [urlForStaticVue, modalMethods],
        data(){
          return{
              newName: null
          }
        },
        computed: {
            nameActiveProject: {
                get: function () {
                    this.newName = this.$store.getters["active/NAME"];
                    return this.$store.getters["active/NAME"];
                },
                set: function (value) {
                    this.newName = value;
                }
            },
            titleImage(){
                return this.$store.getters["active/TITLE_IMG"];
            }
        },
        methods: {
            writeName: function () {
                this.hideModal('project-edit-modal');
                this.$store.dispatch("active/NAME", this.newName);
            }
        }
    }
</script>

<style scoped>

</style>
